// extracted by mini-css-extract-plugin
export default {"blackjackOneTableResult__row":"vz_vA","blackjackOneTableResult__score":"vz_vB","blackjackOneTableResult__scoreLabel":"vz_vC"};